module.exports = __webpack_public_path__ + "img/breadface_thumb.9d025056.jpg";